import { atom } from "~/observers/jotai";

import type { PersonalTrainerExercises } from "./types";

export const personalTrainerExercisesAtom = atom<
	PersonalTrainerExercises | undefined
>(undefined);
